import { Quote } from "lucide-react";
import { GoogleIcon } from "./icons";
import { Reveal, SectionHead } from "./Reveal";

const REVIEWS = [
  {
    name: "Guga Pacheco",
    text: "“Já é a segunda vez que uso o serviço. Rápido, educado e eficiente. Super recomendo!!!”",
    url: "https://www.google.com/maps/contrib/115199343987143824968/reviews?authuser=1&hl=pt-BR",
  },
  {
    name: "Telma Rodrigues",
    text: "“O Saulo é um excelente técnico, honesto e explica muito bem o serviço. Super recomendo.”",
    url: "https://www.google.com/maps/contrib/108568638742505493973/reviews?authuser=1&hl=pt-BR",
  },
  {
    name: "Marcio Pavanello",
    text: "“Excelente profissional! Rápido no atendimento, clareza na explicação do equipamento, ótima postura.”",
    url: "https://www.google.com/maps/contrib/100803798979449021190/reviews?authuser=1&hl=pt-BR",
  },
  {
    name: "Ricardo Brunelli",
    text: "“Saulo (o prestador) foi extremamente profissional e honesto. Claro em seu atendimento e solucionou totalmente o problema. Foi ótimo.”",
    url: "https://www.google.com/maps/contrib/117991907381879778098/reviews?authuser=1&hl=pt-BR",
  },
];

export default function Avaliacoes() {
  return (
    <section id="avaliacoes" data-testid="hidropro-reviews-section" className="relative py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          index="08"
          label="Avaliações"
          title="O que nossos clientes dizem sobre a HidroPro Serviços Técnicos."
          lead="A confiança é construída em cada atendimento. Veja a experiência de clientes que já contrataram nossos serviços."
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4 lg:gap-6">
          {REVIEWS.map((review, i) => (
            <Reveal key={review.name} delay={(i % 4) * 0.08} className="h-full">
              <figure className="flex h-full flex-col rounded-2xl border border-[rgba(10,92,140,0.16)] bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_44px_rgba(10,92,140,0.14)]">
                <Quote className="h-6 w-6 shrink-0 text-[#0A5C8C]/35" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-[#1A1A1A]">{review.text}</blockquote>
                <figcaption className="mt-5 border-t border-[rgba(10,92,140,0.12)] pt-4">
                  <p className="font-display text-base font-bold text-[#0A5C8C]">{review.name}</p>
                  <a
                    href={review.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`hidropro-review-${i + 1}-link`}
                    className="mt-2 inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500 transition-colors hover:text-[#0A5C8C]"
                  >
                    <GoogleIcon className="h-3.5 w-3.5" />
                    Avaliação publicada no Google
                  </a>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col items-center gap-5 rounded-2xl border border-[rgba(10,92,140,0.2)] bg-paper px-6 py-8 text-center lg:mt-14">
            <p className="max-w-2xl text-sm leading-relaxed text-slate-600 sm:text-base">
              Já contratou nossos serviços? Sua opinião também é importante! As avaliações ajudam outras pessoas a
              conhecerem a experiência de quem já confiou na HidroPro Serviços Técnicos.
            </p>
            <a
              href="https://www.google.com/maps/search/HidroPro+Servi%C3%A7os+T%C3%A9cnicos"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hidropro-reviews-google-button"
              className="inline-flex h-12 items-center gap-2.5 rounded-full bg-[#0A5C8C] px-6 text-sm font-semibold text-white shadow-[0_10px_30px_rgba(10,92,140,0.3)] transition-all duration-300 hover:bg-brand-dark active:scale-[0.98] sm:text-base"
            >
              <GoogleIcon className="h-5 w-5" />
              Ver avaliações no Google
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
